import React from 'react';
import { USER_MANAGER_ACCESS } from '../../global/app-global-values';
import App from './components/app/App';

const UserManager = () => <App />;

export default {
  routeProps: {
    path: '/user-manager',
    component: UserManager,
  },
  name: 'UserManager',
  label: 'User Manager',
  iconClassName: 'icon-users',
  active: true,
  accessGroup: USER_MANAGER_ACCESS,
};
